import React, { Component } from 'react';
import Web3 from 'web3'
import BigFamily from '../abis/BigFamily.json'
import logo from '../logo.png';
import './App.css';


////////////////////////////////////////////////////////////////////////////////////////


class App extends Component {


  async componentWillMount() {
    await this.loadWeb3()
    if(this.state.Web3Status)
      await this.loadBlockchainData()
  }

  componentDidMount() {
    this.interval = setInterval(() => { 
      if (this.state.Family != null){
        this.updateContractInfo()
        //console.log('time update')
      }
    }, 1000);
  }

  componentWillUnmount() {
    clearInterval(this.interval);
  }

  async loadBlockchainData() {
    const web3 = window.web3
    const accounts = await web3.eth.getAccounts()
    console.log('account address: ' + accounts)
    this.setState({ account: accounts[0] })

    const networkId = await web3.eth.net.getId()
    const networkData = BigFamily.networks[networkId]
    if(networkData) {
      try{
          const family = web3.eth.Contract(BigFamily.abi, networkData.address)
          this.setState({Family: family})
          console.log('contract address: ' + family.address)

          this.updateState(family, true)

          this.setState({ContractStatus: true})

        }catch(e){
          this.setState({ContractStatus: false})
          console.error(e.message);
          window.alert('Sorry for contract retrieval error.')
        }
      
    } else {
      this.setState({ContractStatus: false})
      window.alert('Contract is not deployed to detected network.')
    }
  }

  async updateState(family, showLog){
    let account = this.state.account
    const familyNum = await family.methods.countFamily().call()
    if(showLog) console.log('family number: ' + familyNum.toString())
    this.setState({FamilyNumber: Number(familyNum.toString())})

    const joined = await family.methods.checkJoined(account).call()
    if(showLog) console.log('joined: ' + joined.toString())
    this.setState({Joined: joined.toString()})

    const parent = await family.methods.findParent(account).call()
    if(showLog) console.log('parent: ' + parent.toString())
    this.setState({Parent: parent.toString()})

    const childerNum = await family.methods.countChildern(account).call()
    if(showLog) console.log('childeren number: ' + childerNum.toString())
    this.setState({ChildNum: Number(childerNum.toString())})

    const grandChilderNum = await family.methods.countGrandChildern(account).call()
    if(showLog) console.log('grand childeren number: ' + grandChilderNum.toString())
    this.setState({GrandChildNum: Number(grandChilderNum.toString())})

    const income = await family.methods.getIncome(account).call()
    if(showLog) console.log('income: ' + income.toString())
    let n_income = Number(income.toString())
    this.setState({Income: n_income})

    const minFee = await family.methods.getLowestJoinFee().call()
    if(showLog) console.log('min entry fee: ' + minFee.toString())
    this.setState({MinFee: Number(minFee.toString())})

    const isOwner = await family.methods.checkOwner(account).call()
    if(showLog) console.log('owner: ' + isOwner.toString())
    this.setState({IsOwner: isOwner.toString()})

    if(isOwner.toString() === 'true'){
      const balance = await family.methods.checkBalance().call()
      if(showLog) console.log('contract balance: ' + balance.toString())
      this.setState({ContractBalance: Number(balance.toString())})
    }
  }



  async loadWeb3() {
    if (window.ethereum) {
      window.web3 = new Web3(window.ethereum)
      await window.ethereum.enable()
      this.setState({Web3Status: true})
    }
    else if (window.web3) {
      window.web3 = new Web3(window.web3.currentProvider)
      this.setState({Web3Status: true})
    }
    else {
      this.setState({Web3Status: false})
      window.alert('Non-Ethereum browser detected. You should consider trying MetaMask!')
    }
  }

  constructor(props) {
    super(props)
    this.state = {
      Web3Status: false,
      ContractStatus: false,
      account: '',
      Family: null,      
    
      FamilyNumber: 0,
      Joined: false,
      Parent: '',
      ChildNum: 0,
      GrandChildNum: 0,
      Income: 0,
      MinFee: 0,
      RefAddress: '',
      ChildAddress: '',

      Message: '',
      IsOwner: false,
      ContractBalance: 0,

      EMPTY_ADDRESS:'0x0000000000000000000000000000000000000000',
    }
    
  }

  async btnAncestorClick(){
    this.setState({Message:''})

    if (this.state.Joined === "true"){
      window.alert('You have already joined.')
      return
    }

    if (!this.state.ContractStatus){
      window.alert('Contract is not ready! Please wait or check errors.')
      return
    }

    if (this.state.Family != null){
      let fee = await this.state.Family.methods.DEFAULT_JOIN_FEE().call()
      console.log('entry fee: ' + fee * 1.0e-18)

      if (window.confirm('Are you sure to build up a new family with ' + fee * 1.0e-18 + ' ETH?')){ 
            this.setState({Message:'Please waiting ...'})
            await this.state.Family.methods.becomeAncestor().send({from: this.state.account, value: fee})
                                      .on('transactionHash', (hash) => {
                                          console.log('Tx hash: ', hash)
                                          //window.alert('Tx hash: ' + hash)
                                          })
                                      .on('confirmation', (confirmationNumber, receipt) => {
                                            console.log('CONFIRMATION receipt:', confirmationNumber, receipt)
                                            this.setState({Message:'Congrats! You have a famliy and ask your friends to join you.'})
                                          
                                      })
                                      .on('error', function (error) { 
                                        console.log("ERROR: ", error.message); 
                                        window.alert('Sorry for an unexpected error. Tx is reverted ')
                                      })
            
        }
    }
  }

  async btnCheckChildClick(){
    this.setState({Message:''})

    if (this.state.Joined === "false"){
      window.alert('You did NOT joined any family.')
      return
    }

    if (!window.web3.utils.isAddress(this.state.ChildAddress)){
      window.alert('Invalid child address!')
      return
    }

    if (!this.state.ContractStatus){
      window.alert('Contract is not ready! Please wait or check errors.')
      return
    }

    if (this.state.Family != null){
        const result = await this.state.Family.methods.checkChild(this.state.account, this.state.ChildAddress).call()
        if(result.toString() === "true"){
          window.alert('Yes, you do have this child!')
        }else{
          window.alert('No, you do NOT have this child!')
        }
    }
  }

  async btnAutoJoinClick(){
      this.setState({Message:''})

      if (this.state.Joined === "true"){
          window.alert('You have already joined.')
          return
      }

      if (!this.state.ContractStatus){
        window.alert('Contract loading error! Please clean your wallet cache and try it again.')
        return
      }

      if (this.state.Family != null){
        if (window.confirm('Are you sure to join a family with ' + this.state.MinFee * 1.0e-18 + ' ETH?')){      
                const parent = await this.state.Family.methods.autoSelectParent().call()
                console.log('auto join:' + parent + ' with ' + this.state.MinFee * 1.0e-18 + ' ETH')
                this.setState({Message:'Please waiting ...'})
                await this.state.Family.methods.joinFamily(parent).send({from: this.state.account, value: this.state.MinFee})
                                              .on('transactionHash', (hash) => {
                                                  console.log('CREATING hash:', hash)
                                                  //window.alert('Tx hash: ' + hash)
                                                  })
                                              .on('confirmation', (confirmationNumber, receipt) => {
                                                    console.log('CONFIRMATION receipt:', confirmationNumber, receipt)
                                                    
                                                    //window.alert('Congrats! Sponsor is confirmed and you could win 50 ETH!')
                                                    if (parent === this.state.EMPTY_ADDRESS)this.setState({Message:'Congrats! You buid up a family as an ancestor.'})
                                                    else this.setState({Message:'Congrats! You have joined the family ' + parent})
                                                    
                                              })
                                              .on('error', function (error) { 
                                                console.log("ERROR: ", error.message); 
                                                window.alert('Sorry for an unexpected error. Tx is reverted!')
                                                
                                              })                    
        }
      }
  }

  async btnJoinClick(parent_address){
    this.setState({Message:''})

    if (this.state.Joined === "true"){
        window.alert('You have already joined.')
        return
    }

    if (!window.web3.utils.isAddress(this.state.RefAddress)){
      window.alert('Invalid parent address!')
      return
    }

    if (!this.state.ContractStatus){
      window.alert('Contract loading error! Please clean your wallet cache and try it again.')
      return
    }

    if (this.state.Family != null){
      const parent_exists = await this.state.Family.methods.checkParentExist(parent_address).call()
      if(parent_exists === 'false'){
        window.alert('The input parent does NOT exist!')
        return
      }
      const fee = await this.state.Family.methods.getJoinFee(parent_address).call()
      console.log('join:' + parent_address + ' with ' + fee * 1.0e-18 + ' ETH')

      if (window.confirm('Are you sure to join the family with ' + fee * 1.0e-18 + ' ETH?')){      
          this.setState({Message:'Please waiting ...'})
          await this.state.Family.methods.joinFamily(parent_address).send({from: this.state.account, value: fee})
                                            .on('transactionHash', (hash) => {
                                                console.log('CREATING hash:', hash)
                                                //window.alert('Tx hash: ' + hash)
                                                })
                                            .on('confirmation', (confirmationNumber, receipt) => {
                                                  console.log('CONFIRMATION receipt:', confirmationNumber, receipt)
                                                  
                                                  //window.alert('Congrats! Sponsor is confirmed and you could win 50 ETH!')
                                                  this.setState({Message:'Congrats! You have joined the family ' + parent_address})
                                                  
                                            })
                                            .on('error', function (error) { 
                                              console.log("ERROR: ", error.message); 
                                              window.alert('Sorry for an unexpected error. Tx is reverted!');
                                              
                                            })                    
      }
    }
}

  async btnWithdrawClick(){
  this.setState({Message:''})

  if (!this.state.ContractStatus){
    window.alert('Contract loading error! Please clean your wallet cache and try it again.')
    return
  }

  if(this.state.IsOwner !== 'true'){
    window.alert('You have no withdraw right.')
    return
  }

  if (this.state.Family != null){
      this.setState({Message:'Please waiting ...'})
      await this.state.Family.methods.withdraw().send({from: this.state.account})
                                          .on('transactionHash', (hash) => {
                                              console.log('CREATING hash:', hash)
                                              //window.alert('Tx hash: ' + hash)
                                              })
                                          .on('confirmation', (confirmationNumber, receipt) => {
                                                console.log('CONFIRMATION receipt:', confirmationNumber, receipt)
                                                
                                                //window.alert('Congrats! Sponsor is confirmed and you could win 50 ETH!')
                                                this.setState({Message:'withdraw done! ' })
                                                
                                          })
                                          .on('error', function (error) { 
                                            console.log("ERROR: ", error.message); 
                                            window.alert('Sorry for an unexpected error. Tx is reverted!')
                                            
                                          })                    
    
  }
}

  refInputHandler = (event) => {
    this.setState({RefAddress: event.target.value});
  }

  childInputHandler = (event) =>{
    this.setState({ChildAddress: event.target.value});
  }



  async updateContractInfo(){
      if(!this.state.ContractStatus)
        return;

      this.updateState(this.state.Family, false)

  }

  render() {
    return (
      <div>
        <nav className="navbar navbar-dark fixed-top bg-dark flex-md-nowrap p-0 shadow">
          <a
            className="navbar-brand col-sm-3 col-md-2 mr-0"
            href="https://dappradar.com/app/1880/lucky-crypto-paintings"
            target="_blank"
            rel="noopener noreferrer"
          >
            Big Family
          </a>
        </nav>
        <div className="container-fluid mt-5">
          <div className="row">
            <main role="main" className="col-lg-12 d-flex text-center">
              <div className="content mr-auto ml-auto">
  
                <h1><img src={logo} className="App-logo" alt="logo" /> Big Family</h1>
                <hr/>
                <p align="left"><font size="5">Welcome to Big Family! Join or establish a family to earn unlimited amount of ETHs. One family = [ 1 parent + N children + N grandchildren ]. The parent's address stands for family ID.</font></p>
                <p align="left"><font size="5">It's very easy to start:</font></p>
                <p align="left"><font size="4">[1] Join/establish a family with entry fee 0.5ETH or less.</font></p>
                <p align="left"><font size="4">[2] Ask your friends to join your family with referring to your address as parent. Then you can get rewards from your children and grand children.</font></p>
                <p align="left"><font size="4">[3] Increase your family members to get more profits. </font></p>
                <p align="left"><font size="5"> Note:  </font></p>
                <p align="left"><font size="4">   1) the more children, the lower entry fee; </font></p>
                <p align="left"><font size="4">   2) the lower entry fee, the more chances you will be automatically assigned with children; </font></p>
                <p align="left"><font size="4">   3) the more children and grandchildren, the more profits; </font></p>
                <p align="left"><font size="4">   4) the offsprings of your grandchildren will NOT contribute to your income;</font></p>
                <p align="left"><font size="4">   5) the [Auto Join] helps you to join a family with lowest entry fee.</font></p>
                <hr/>
                <div className="Draw_Items"> 
                  <ul>
                    <p align="left"><font size="5">Total family number: {this.state.ContractStatus ? this.state.FamilyNumber: "?"}</font></p>
                    <p align="left"><font size="5">You joined?: {this.state.ContractStatus ? this.state.Joined: "?"}</font></p>
                    <p align="left"><font size="5">Your address: {this.state.ContractStatus ? this.state.account: "?"}</font></p>                   
                    <p align="left"><font size="5">Your parent address: {this.state.ContractStatus ? (this.state.Parent===this.state.EMPTY_ADDRESS? "None": this.state.Parent): "?"}</font></p>
                    <p align="left"><font size="5">Your Child Number: {this.state.ContractStatus ? this.state.ChildNum: "?"}</font></p>
                    <p align="left"><font size="5">Your Grandchild Number: {this.state.ContractStatus ? this.state.GrandChildNum: "?"}</font></p>
                    <p align="left"><font size="5">Your income: {this.state.ContractStatus ? this.state.Income* 1.0e-18: "?"} ETH</font></p>
                    <p align="left"><font size="5">Lowest entry fee: {this.state.ContractStatus ? this.state.MinFee * 1.0e-18: "?"} ETH</font></p>
                    <span>&nbsp;&nbsp;</span>
                    <p align="left">Message: {this.state.ContractStatus ? this.state.Message: ""}</p> 
                    <hr/>
                    <p align="left">Your child address: <input type="text"  style={{width: "400px"}} onChange={this.childInputHandler}/>
                      &nbsp;&nbsp;&nbsp;<button style={{width: "150px"}} onClick={this.btnCheckChildClick.bind(this, this.state.ChildAddress)}> Check Child</button>
                    </p>
                    <hr/>
                    <p align="left">Enter ref. address: <input disabled={this.state.Joined==='true'} type="text"  style={{width: "400px"}} onChange={this.refInputHandler}/>
                      &nbsp;&nbsp;&nbsp;<button disabled={this.state.Joined==='true'} style={{width: "150px"}} onClick={this.btnJoinClick.bind(this, this.state.RefAddress)}> Join with ref.</button>
                    </p>
                    <span>&nbsp;&nbsp;</span>
                    <p align="left"><button disabled={this.state.Joined==='true'} style={{width: "150px"}} onClick={this.btnAutoJoinClick.bind(this)}>Auto Join</button>&nbsp;&nbsp;&nbsp;<button disabled={this.state.Joined==='true'} onClick={this.btnAncestorClick.bind(this)}>Become Ancestor</button></p>
                    <hr/>
                    <p align="left">{this.state.IsOwner==='true'? this.state.ContractBalance*1.0e-18: ''}</p>
                    <p align="left">{this.state.IsOwner==='true' && <button style={{width: "150px"}} onClick={this.btnWithdrawClick.bind(this)}>Withdraw</button>}</p>
                  </ul>
                </div>

              </div>
            </main>
          </div>
        </div>
      </div>
    );
  }
}

export default App;
